(function () {
  if (window.kidisChristmasCatalogue) return;
  window.kidisChristmasCatalogue = true;
  var cache = new Map(), version = 0;
  function root() { return document.querySelector('.kidis-christmas-catalogue'); }
  function main() { var r = root(); return r && r.querySelector('.kidis-catalogue__main'); }
  function base() { return new URL(root().dataset.christmasBase, location.origin); }
  function allowed() { return Array.from(root().querySelectorAll('[data-christmas-category]')); }
  function targetFromLocation() {
    var handle = new URL(location.href).searchParams.get('kidis_category');
    var link = allowed().find(function (a) { return a.dataset.christmasCategory === handle; });
    var url = link ? new URL(link.href) : base();
    new URL(location.href).searchParams.forEach(function (v, k) { if (k !== 'kidis_category') url.searchParams.append(k, v); });
    return url;
  }
  function request(url) {
    var key = url.toString();
    if (!cache.has(key)) {
      var fetchUrl = new URL(key); fetchUrl.searchParams.set('section_id', 'kidis-christmas-products');
      cache.set(key, fetch(fetchUrl, { credentials: 'same-origin' }).then(function (r) { if (!r.ok || r.redirected) throw Error('request'); return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), panel = doc.querySelector('.kidis-catalogue__main');
        if (!panel) throw Error('content'); return panel;
      }).catch(function (err) { cache.delete(key); throw err; }));
      if (cache.size > 20) cache.delete(cache.keys().next().value);
    }
    return cache.get(key);
  }
  function pageUrl(target) {
    var url = base(); url.search = target.search;
    if (target.pathname !== url.pathname) url.searchParams.set('kidis_category', target.pathname.split('/').filter(Boolean).pop());
    return url;
  }
  function select(target) {
    var matched;
    allowed().forEach(function (a) { if (new URL(a.href).pathname === target.pathname) { a.setAttribute('aria-current', 'page'); matched = a; } else a.removeAttribute('aria-current'); });
    var name = matched ? (matched.querySelector('[data-christmas-featured-label]') || matched).textContent.trim() : 'Alle Weihnachtsprodukte';
    var currentLabel = root().querySelector('[data-christmas-current]');
    if (currentLabel) currentLabel.textContent = name;
  }
  function jumpToProducts() {
    var panel = main(); if (!panel) return;
    var top = 0;
    document.querySelectorAll('.shopify-section-group-header-group,.header-section,header-section,.header-wrapper,header-nav,.site-header,.site-header__element--sub,.km-host').forEach(function (el) {
      var rect = el.getBoundingClientRect(), css = getComputedStyle(el);
      if (rect.width && rect.height && rect.top < 240 && rect.bottom > 0 && css.display !== 'none' && css.visibility !== 'hidden') top = Math.max(top, rect.bottom);
    });
    window.scrollTo({ top: Math.max(0, window.scrollY + panel.getBoundingClientRect().top - top - 16), behavior: 'instant' });
  }
  async function load(url, push, append) {
    var id = ++version, current = main(); if (!current) return;
    current.setAttribute('aria-busy', 'true');
    var status = root().querySelector('[role="status"]'); status.hidden = true;
    try {
      var panel = (await request(url)).cloneNode(true); if (id !== version) return;
      panel.id = 'kidis-christmas-product-grid';
      if (append) {
        var grid = current.querySelector('.collection-grid'), nextGrid = panel.querySelector('.collection-grid');
        if (!grid || !nextGrid) throw Error('grid');
        grid.querySelectorAll('[data-kidis-load-more]').forEach(function (n) { n.remove(); });
        Array.from(nextGrid.children).forEach(function (n) { grid.appendChild(n); });
      } else {
        current.replaceWith(panel);
        panel.querySelectorAll('script[type="module"]').forEach(function (old) { var script = document.createElement('script'); script.type = 'module'; script.textContent = old.textContent; old.replaceWith(script); });
      }
      select(url);
      if (push) history.pushState({ kidisChristmas: true }, '', pageUrl(url));
      document.dispatchEvent(new CustomEvent('collection:reloaded', { bubbles: true }));
    } catch (err) {
      if (id === version) { status.textContent = 'Produkte konnten nicht geladen werden. Bitte nochmals auswählen.'; status.hidden = false; }
    } finally { if (id === version && main()) main().removeAttribute('aria-busy'); }
  }
  function start() {
    if (!root()) return;
    if (main()) main().id = 'kidis-christmas-product-grid';
    var panel = root().querySelector('.kidis-christmas-navigation-panel'); panel.open = true;
    // Reuse the configured featured collection if it changes in the theme editor.
    var featured = document.querySelector('[data-christmas-featured-target]');
    var featuredNav = root().querySelector('[data-christmas-featured-navigation]');
    if (featured && featuredNav) {
      featuredNav.href = featured.href;
      featuredNav.dataset.christmasCategory = featured.dataset.christmasCategory;
      var heading = featured.closest('.kidis-christmas-featured').querySelector('h2');
      var label = featuredNav.querySelector('[data-christmas-featured-label]');
      if (heading && label) label.textContent = heading.textContent;
      if (!(navigator.connection && navigator.connection.saveData)) request(new URL(featured.href)).catch(function () {});
    }
    panel.querySelector(':scope > summary').addEventListener('click', function (e) {
      if (matchMedia('(max-width: 768px)').matches) { e.preventDefault(); panel.open = true; }
    });
    var groups = panel.querySelector('.kidis-christmas-groups');
    var scrollMore = panel.querySelector('[data-christmas-scroll-more]');
    function updateScrollHint() {
      if (!groups || !scrollMore) return;
      scrollMore.hidden = !matchMedia('(max-width: 768px)').matches || groups.scrollHeight - groups.clientHeight - groups.scrollTop <= 4;
    }
    if (groups && scrollMore) {
      groups.addEventListener('scroll', updateScrollHint, { passive: true });
      groups.addEventListener('toggle', function () { requestAnimationFrame(updateScrollHint); }, true);
      scrollMore.addEventListener('click', function () {
        groups.scrollBy({ top: Math.round(groups.clientHeight * .7), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
      window.addEventListener('resize', updateScrollHint, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(updateScrollHint).observe(groups);
      requestAnimationFrame(updateScrollHint);
    }
    select(targetFromLocation());
    if (new URL(location.href).searchParams.has('kidis_category')) {
      load(targetFromLocation(), false).then(function () { if (location.hash === '#kidis-christmas-product-grid') jumpToProducts(); });
      if (location.hash === '#kidis-christmas-product-grid') jumpToProducts();
    }
    document.addEventListener('input', function (e) {
      if (!e.target.matches('[data-christmas-search]')) return;
      var term = e.target.value.toLocaleLowerCase();
      root().querySelectorAll('.kidis-christmas-group').forEach(function (group) {
        var visible = 0; group.querySelectorAll('a').forEach(function (a) { a.hidden = !a.textContent.toLocaleLowerCase().includes(term); if (!a.hidden) visible++; });
        group.hidden = !visible; if (term) group.open = true;
      });
      if (groups) groups.scrollTop = 0;
      requestAnimationFrame(updateScrollHint);
    });
    document.addEventListener('pointerover', function (e) {
      var a = e.target.closest('[data-christmas-category]');
      if (a && (root().contains(a) || a.hasAttribute('data-christmas-featured-target')) && !(navigator.connection && navigator.connection.saveData)) request(new URL(a.href)).catch(function () {});
    }, { passive: true });
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || !root()) return;
      var a = e.target.closest('a'); if (!a || a.target || a.hasAttribute('download') || (!root().contains(a) && !a.hasAttribute('data-christmas-featured-target'))) return;
      if (a.hasAttribute('data-christmas-category')) { e.preventDefault(); e.stopImmediatePropagation(); load(new URL(a.href), true); jumpToProducts(); }
      else if (main().contains(a) && (a.matches('.kidis-load-more__btn') || a.closest('active-tags, .active-tags'))) {
        var u = new URL(a.href); if (u.origin !== location.origin || !u.pathname.includes('/collections/')) return;
        e.preventDefault(); e.stopImmediatePropagation(); load(u, true, a.matches('.kidis-load-more__btn'));
      }
    }, true);
    document.addEventListener('ajaxCollection:render', function (e) {
      if (!root() || !main().contains(e.target)) return;
      e.stopImmediatePropagation(); var url = e.detail && e.detail.newUrl ? new URL(e.detail.newUrl) : targetFromLocation();
      if (!(e.detail && e.detail.newUrl)) { var sort = url.searchParams.get('sort_by'); url.search = ''; if (sort) url.searchParams.set('sort_by', sort); }
      if (e.detail && e.detail.formData) new URLSearchParams(e.detail.formData).forEach(function (v, k) { url.searchParams.append(k, v); });
      load(url, true);
    }, true);
    document.addEventListener('sort:selected', function (e) {
      if (!root() || !main().contains(e.target)) return;
      e.stopImmediatePropagation(); var url = targetFromLocation(); url.searchParams.set('sort_by', e.detail.sortValue); url.searchParams.delete('page'); load(url, true);
    }, true);
    window.addEventListener('popstate', function () { if (root()) load(targetFromLocation(), false); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();